"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.command = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var command = function command(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'command-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M7.87517 9.02261V10.9707L7.01859 10.9774C5.90305 10.9774 5 11.8551 5 12.9787C5 14.0957 5.90305 15 7.01859 15C8.12749 15 9.03718 14.0891 9.03718 12.9787V12.1277H10.9628V12.9787C10.9628 14.0891 11.8725 15 12.9814 15C14.0969 15 15 14.0957 15 12.9787C15 11.8551 14.0969 10.9774 12.9814 10.9774L12.1182 10.9707V9.02261H12.9814C14.0969 9.01596 15 8.14495 15 7.02128C15 5.90426 14.0969 5 12.9814 5C11.8725 5 10.9628 5.9109 10.9628 7.02128V7.87234H9.03718V7.02128C9.03718 5.9109 8.12749 5 7.01859 5C5.90305 5 5 5.90426 5 7.02128C5 8.14495 5.90305 9.01596 7.01859 9.02261H7.87517ZM7.04515 7.88564C6.55378 7.88564 6.16866 7.5 6.16866 7.02128C6.16866 6.5492 6.55378 6.17021 7.01859 6.17021C7.4834 6.17021 7.87517 6.55585 7.87517 7.04787V7.88564H7.04515ZM12.9548 7.88564H12.1248V7.04787C12.1248 6.55585 12.5166 6.17021 12.9814 6.17021C13.4462 6.17021 13.8313 6.5492 13.8313 7.02128C13.8313 7.5 13.4396 7.88564 12.9548 7.88564ZM9.03718 10.984V9.01596H10.9628V10.984H9.03718ZM7.04515 12.1144H7.87517V12.9455C7.87517 13.4375 7.4834 13.8298 7.01859 13.8298C6.55378 13.8298 6.16866 13.4441 6.16866 12.9721C6.16866 12.5 6.55378 12.1144 7.04515 12.1144ZM12.9548 12.1144C13.4396 12.1144 13.8313 12.5 13.8313 12.9721C13.8313 13.4441 13.4462 13.8298 12.9814 13.8298C12.5166 13.8298 12.1248 13.4375 12.1248 12.9455V12.1144H12.9548Z',
    fill: '#4B5563'
  }));
};

exports.command = command;